const COMMISSION_LABELS = {
    client: {
        long: 'Agency Fee',
        short: 'Ag. Fee',
    },
    agency: {
        long: 'Mother Agency Commission',
        short: 'Mot. Ag. Comm.',
    },
    model: {
        long: 'Agency Commission',
        short: 'Comm.',
    },
    service: {
        long: 'Commission',
        short: 'Comm.',
    },
    default: {
        long: 'Commission',
        short: 'Comm.',
    },
};

export const getCommissionLabel = ({ statementType, variant = 'long' } = {}) => {
    const normalizedType = statementType ? statementType.toLowerCase() : 'default';
    const labels = COMMISSION_LABELS[normalizedType] || COMMISSION_LABELS.default;

    return labels[variant] || labels.long;
};

export const isMainStatementLine = (statement) => {
    return !statement?.isCommission && !statement?.isClientAdvance;
};
